//NEW: UI_REVAMP
import { Box } from '@chakra-ui/react';
import { RECORD_GRADIENTS, RECORD_SHADOWS } from '../../styles/recordUiTokens';

const VARIANTS = {
	goldBlack: {
		bgGradient: RECORD_GRADIENTS.goldBorder,
		boxShadow: '0 4px 10px rgba(46, 124, 230, 0.3)',
	},
	goldYellow: {
		bgGradient: RECORD_GRADIENTS.straightBadge,
		boxShadow: '',
	},
	purpleWhite: {
		bgGradient: RECORD_GRADIENTS.purpleWhiteBorder,
		boxShadow: RECORD_SHADOWS.purpleWhite,
	},
};

const GradientBox = ({ children, variant = 'goldBlack', borderRadius = '16px', ...props }) => {
	const { bgGradient, boxShadow } = VARIANTS[variant];

	return (
		<Box
			position='relative'
			bgGradient={bgGradient}
			p={0.5}
			borderRadius={borderRadius}
			boxShadow={boxShadow}
			{...props}
		>
			{children}
		</Box>
	);
};

export default GradientBox;
